import { render, staticRenderFns } from "./segmentForm.vue?vue&type=template&id=6145a2de&lang=pug"
import script from "./segmentForm.vue?vue&type=script&lang=js"
export * from "./segmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports